import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
export default function ReviewTab({
  setActiveTab,
  data,
  setExperts,
  setProject_id,
}) {
  const [initializePopup, setInitializePopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const projectInitializeHandler = () => {
    setInitializePopup(true);
    const url = `${API_URL}list-setup`;
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setInitializePopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "List has been initialized. No suggested experts found for this project.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/app/ListsOverview/";
          });
        } else if (data.status === "error" && data.message) {
          console.log(data.message);
          Swal.fire({
            title: "Error!",
            text: data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else
          Swal.fire({
            title: "Error!",
            text: "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
          });
      });
  };

  return (
    <>
      <fieldset>
        <div className="form-card review-project-setup">
          <h4 className="text-muted">List Details</h4>
          {/* <div className='row'>
                    <p className='col-3 text-muted'>Lead Email</p>
                    <p className='col-9'>
                        {data.leadEmail}
                    </p>
                </div>
                <div className='row'>
                    <p className='col-3 text-muted'>Client Owner</p>
                    <p className='col-9'>
                        {data.clientOwner}
                    </p>
                </div> */}
          <div className="row">
            <p className="col-3 text-muted">List Name</p>
            <p className="col-9">{data.projectName}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">List Description</p>
            <p className="col-9">{data.projectDescription}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Region</p>
            <p className="col-9">{data.projectRegion}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Country</p>
            <p className="col-9">{data.projectLocation}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Industy Preference</p>
            <p className="col-9">{data.projectIndustyPreference}</p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Industy</p>
            <p className="col-9">
              {data.projectIndustyPreferenceList.map((industry, index) => {
                if (index < data.projectIndustyPreferenceList.length - 1) {
                  return <span key={index}>{industry.name}, </span>;
                } else {
                  return <span key={index}>{industry.name}</span>;
                }
              })}
            </p>
          </div>
          {/* <div className='row'>
                    <p className='col-3 text-muted'>Daily Budget</p>
                    <p className='col-9'>
                        {data.projectDailyBudget}
                    </p>
                </div> */}
          <div className="row">
            <p className="col-3 text-muted">List Category</p>
            <p className="col-9">{data.projectCategory}</p>
          </div>

          <h4 className="text-muted mt-3">Profile Details</h4>
          <div className="row">
            <p className="col-3 text-muted">Profile Type</p>
            <p className="col-9">
              {data.projectConsultantType === "con"
                ? "Consultants (Long-term project support)"
                : data.projectConsultantType === "exp"
                ? "Experts (Expert call)"
                : ""}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Seniority</p>
            <p className="col-9">
              {data.projectSeniority?.map((seniority, index) => {
                if (index < data.projectSeniority?.length - 1) {
                  return <span key={index}>{seniority.name}, </span>;
                } else {
                  return <span key={index}>{seniority.name}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Suggested Skills</p>
            <p className="col-9">
              {data.projectSuggestedSkills.map((skill, index) => {
                if (index < data.projectSuggestedSkills?.length - 1) {
                  return <span key={index}>{skill}, </span>;
                } else {
                  return <span key={index}>{skill}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Other Skills</p>
            <p className="col-9">
              {data.projectSkillsRequirements.map((skill, index) => {
                if (index < data.projectSkillsRequirements?.length - 1) {
                  return <span key={index}>{skill.value}, </span>;
                } else {
                  return <span key={index}>{skill.value}</span>;
                }
              })}
            </p>
          </div>
          <div className="row">
            <p className="col-3 text-muted">Language</p>
            <p className="col-9">
              {data.projectLanguages.map((language, index) => {
                if (index < data.projectLanguages?.length - 1) {
                  return <span key={index}>{language.name}, </span>;
                } else {
                  return <span key={index}>{language.name}</span>;
                }
              })}
            </p>
          </div>
          {/* <div className='row'>
                    <p className='col-3 text-muted'>Project Start Date</p>
                    <p className='col-9'>
                        {data.projectStartDate}
                    </p>
                </div>
                <div className='row'>
                    <p className='col-3 text-muted'>Project Duration</p>
                    <p className='col-9'>
                        {data.projectDuration}
                    </p>
                </div>
                <div className='row'>
                    <p className='col-3 text-muted'>Type of Employment</p>
                    <p className='col-9'>
                        {data.projectTypeOfEmployment} 
                        {data.projectTypeOfEmployment === 'Hybrid' && 
                        <span> 
                            {data.projectRemoteOption && <span> (Remote {data.projectRemoteOption}%,</span>} 
                            {data.projectOnsiteOption && <span> Onsite {data.projectOnsiteOption}%)</span>}
                        </span>}
                    </p>
                </div> */}
        </div>
        <input
          onClick={projectInitializeHandler}
          type="submit"
          className="next action-button"
          value="Initialize"
        />
        <input
          onClick={() => setActiveTab("profileDetails")}
          type="button"
          className="previous action-button-previous"
          defaultValue="Previous"
        />
      </fieldset>

      {initializePopup && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Initializing List...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
